module.exports = __webpack_public_path__ + "img/fashion_64.83a4fce9.jpg";